// removed by extract-text-webpack-plugin
module.exports = {"container":"_3GOdyrqa5EQTTF_KbUO_GS","btnContainer":"_2L3GPofv6J6RM3xD3M1nDP","marketName":"_2HTn_qCJF5Ka6V7yRdY2gA","marketNameSelected":"_1LoMIECNgDe0OcHRu8vCle","text":"moQhLXuPNPfUn7hzEaH2p","iconContainer":"_2Q036i2rtwhBoEKeC4gPT6"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Exchange/Layout/Navbar/Markets/Button/styles.css
// module id = 1615
// module chunks = 85